export default "__VITE_ASSET__BM9iPZF___"